module.exports = __webpack_public_path__ + "media/images/MaintenanceIcon-035d9a2f525a742f8d6bfbac8ca0b7ee.svg";